import { render, staticRenderFns } from "./GroupControlMana1.vue?vue&type=template&id=604a452d&scoped=true&"
import script from "./GroupControlMana1.vue?vue&type=script&lang=js&"
export * from "./GroupControlMana1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a452d",
  null
  
)

export default component.exports